//PUBLIC_GET ALL SUBSCRIPTION
export const PUBLIC_GET_ALL_SUBSCRIPTION_REQUEST =
  "PUBLIC_GET_ALL_SUBSCRIPTION_REQUEST";
export const PUBLIC_GET_ALL_SUBSCRIPTION_SUCCESS =
  "PUBLIC_GET_ALL_SUBSCRIPTION_SUCCESS";
export const PUBLIC_GET_ALL_SUBSCRIPTION_FAIL =
  "PUBLIC_GET_ALL_SUBSCRIPTION_FAIL";
